import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
import useApi from 'hooks/useApi';

// types
import { GuardProps } from 'types/auth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, isLoginInitiated, isInitialized } = useApi();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if initialization is complete and user is not logged in
    if (isInitialized && isLoginInitiated && !isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location, isLoginInitiated, isInitialized]);

  // Show nothing while initializing (ApiContext will show Loader)
  if (!isInitialized) {
    return null;
  }

  return children;
};

export default AuthGuard;
